import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

export const RolesView = angular
  .module('acme.view.application.roles', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.roles.controllers',
    'acme.view.application.roles.list',
    'acme.view.application.roles.permissions',
  ])

  .config(function config($stateProvider) {
    // Create both abstract view and template view.
    // Abstract Views are enabled by default
    const roles = {
      name: 'application.roles',
      url: '/roles',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'RolesController',
          templateUrl: 'views/application/views/roles/roles.tpl.html',
        },
      },
    };

    $stateProvider.state(roles);
  }).name;
